import { Ordering } from '@/types/graphql';
import { queuesForVariation } from '@axle-health/work-queue-definitions';

import { defaultPatientsRowToLink, defaultVisitsRowToLink } from '../definitions';
import { definitionFor, fromDefinition } from '../fromDefinition';
import { PatientDashboardContainer, VisitDashboardContainer } from '../types';
import { ELEANOR_CONTAINER_KEYS } from './containerKeys/containerKeys';
import { IDashboardVariationConfig } from './types';

const PUBLISHED_QUEUES = queuesForVariation('ELEANOR_HEALTH');

const RN_POSITION_NEEDED_CONTAINER: VisitDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, ELEANOR_CONTAINER_KEYS.rnPositionNeeded),
    {
        defaultEnabled: true,
        hoverText: 'Visit requires RN clinician appointment to be added.',
        tableConfig: {
            rowToLink: defaultVisitsRowToLink,
            emptyTableText: 'No new patient visits need RN positions at this time',
            ordering: { patient: { fullName: Ordering.ASC } },
        },
    },
);

const UNASSIGNED_CONTAINER: VisitDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, ELEANOR_CONTAINER_KEYS.unassigned),
    {
        defaultEnabled: true,
        hoverText: 'Visits in need of a clinician assignment.',
        tableConfig: {
            rowToLink: defaultVisitsRowToLink,
            emptyTableText: 'No unassigned visits at this time',
            ordering: { startDatetime: Ordering.ASC },
        },
    },
);

const RN_PATIENT_PAYER_MISMATCH_CONTAINER: VisitDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, ELEANOR_CONTAINER_KEYS.rnPatientPayerMismatch),
    {
        defaultEnabled: true,
        hoverText: 'Visits with clinician and patient payer mismatches.',
        tableConfig: {
            rowToLink: defaultVisitsRowToLink,
            emptyTableText: 'No payer mismatches at this time.',
            ordering: { patient: { fullName: Ordering.ASC } },
        },
    },
);

const VISIT_CLINICIAN_APPOINTMENT_SYNC_ISSUES_CONTAINER: VisitDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, ELEANOR_CONTAINER_KEYS.visitClinicianAppointmentSyncIssues),
    {
        defaultEnabled: true,
        hoverText: 'Visits unable to be synced to EMR.',
        tableConfig: {
            rowToLink: defaultVisitsRowToLink,
            emptyTableText: 'No sync issues at this time.',
            ordering: { patient: { fullName: Ordering.ASC } },
        },
    },
);

const UNSYNCED_PATIENTS_CONTAINER: PatientDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, ELEANOR_CONTAINER_KEYS.unsyncedPatients),
    {
        defaultEnabled: true,
        hoverText: 'Patients unable to be synced to EMR.',
        tableConfig: {
            rowToLink: defaultPatientsRowToLink,
            emptyTableText: 'No sync issues at this time',
            ordering: { fullName: Ordering.ASC },
        },
    },
);

export const ELEANOR_HEALTH_DASHBOARD_CONFIG: IDashboardVariationConfig = {
    containers: [
        RN_POSITION_NEEDED_CONTAINER,
        UNASSIGNED_CONTAINER,
        RN_PATIENT_PAYER_MISMATCH_CONTAINER,
        VISIT_CLINICIAN_APPOINTMENT_SYNC_ISSUES_CONTAINER,
        UNSYNCED_PATIENTS_CONTAINER,
    ],
};
